// ----------------------------------------------------------------------------- //
// Toggle the site header when user scroll up or down
// ----------------------------------------------------------------------------- //
const masthead = document.getElementById("masthead");

if ( masthead ) {

	let lastScroll = 0;

	window.addEventListener("scroll", () => {

		let scrollPosition = window.scrollY;
		let currentScroll = window.scrollY;

		if ( scrollPosition > 0 ) {
			masthead.classList.add("is-sticky");
		} else {
			masthead.classList.remove("is-sticky");
		}

		if ( currentScroll <= masthead.offsetHeight * 2 ) {
			masthead.classList.remove( 'js-scroll-up' );
			return;
		}

		if ( currentScroll > lastScroll ) {

			const submenuTrigger = masthead.querySelectorAll('.js-dropdown-toggle');

			// Close any submenu that may possibly be expanded when scrolling down
			if ( submenuTrigger.length ) {
				submenuTrigger.forEach((btn) => {
					if ( btn.getAttribute("aria-expanded") == "true") {
						btn.setAttribute("aria-expanded", "false");
						btn.nextElementSibling.setAttribute("aria-hidden", "true");
						btn.closest('li').classList.toggle('is-expanded');
					}
				});
			}

			masthead.classList.remove( 'js-scroll-up' );
			masthead.classList.add( 'js-scroll-down' );

		} else if ( currentScroll < lastScroll ) {
			masthead.classList.remove( 'js-scroll-down' );
			masthead.classList.add( 'js-scroll-up' );
		}

		lastScroll = currentScroll;
	});
}
